import { createRoute } from '@tanstack/react-router';
import { PaymentDocuments } from '../payment-documents/index.js';
import { rootRoute } from './index.js';

export const paymentDocumentsRoute = createRoute({
    getParentRoute: () => rootRoute,
    path: '/payment-documents',
    component: PaymentDocuments,
});
